import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Directory from './components/common/Directory.vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSocialSharing from 'vue-social-sharing'
import VueTheMask from 'vue-the-mask'
import * as VueSpinnersCss from "vue-spinners-css";

Vue.use(VueSpinnersCss)
Vue.use(VueSocialSharing)
Vue.use(VueTheMask)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBARdXXfW9RMmU3vuKrcEPKo_7OCMDJbWM',
    libraries: 'places', 
  },
  installComponents: true
})
window.lang = 'ru'
Vue.config.productionTip = false
Vue.component('directory', Directory)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
